import { PAYMENT_ACCOUNT_DETAILS } from '../constants/payment';

export const generatePaymentReference = () => {
  const datePart = new Date().toISOString().slice(0, 10).replace(/-/g, '');
  const randomPart = Math.random().toString(36).slice(2, 8).toUpperCase();
  return `KAM-${datePart}-${randomPart}`;
};

export const buildWhatsAppPaymentMessage = ({
  productTitle,
  productPrice,
  currencyCode,
  productUrl,
  productImage,
  proofUrl,
  referenceId,
  shippingCompany,
  shippingFee,
  shippingEta,
  totalCost,
}) => {
  return [
    'Hello Customer Care,',
    '',
    'I have completed payment. Please find the details below:',
    '',
    '*ORDER DETAILS*',
    `- Product: ${productTitle}`,
    `- Product Price: ${productPrice} ${currencyCode || ''}`,
    `- Shipping Option: ${shippingCompany}`,
    `- Shipping Fee: ${shippingFee}`,
    `- Shipping ETA: ${shippingEta}`,
    `- Total Paid: ${totalCost}`,
    `- Reference: ${referenceId}`,
    '',
    '*PAYMENT ACCOUNT*',
    `- Account Name: ${PAYMENT_ACCOUNT_DETAILS.accountName}`,
    `- Bank: ${PAYMENT_ACCOUNT_DETAILS.bankName}`,
    `- Account Number: ${PAYMENT_ACCOUNT_DETAILS.accountNumber}`,
    '',
    '*ATTACHMENTS*',
    `- Proof of Transfer: ${proofUrl}`,
    `- Product Link: ${productUrl}`,
    `- Product Image: ${productImage}`,
    '',
    'Kindly confirm and proceed with my order. Thank you.',
  ].join('\n');
};
